export default __webpack_public_path__ + "static/media/rightarrow.005c7a1e.svg";